<template>
  <el-dialog
      :visible="visible"
    :width="width"
    destroy-on-close
    @close="handleClose"
  >

    <!-- 邮箱登录表单 -->
    <div v-if="loginType === 'email'">
      <div class="flex flex-row items-center mt-[5px] text-[12px]">
        <span>没有账号？将自动完成注册！</span>
      </div>
      <!-- 原有的邮箱登录表单内容 -->
      <div class="my-[20px]">
        <el-form :model="formData" label-width="auto" label-position="top">
          <el-form-item label="邮箱">
            <el-input v-model="formData.email" placeholder="请输入邮箱" />
          </el-form-item>
          <el-form-item label="验证码">
            <el-input v-model="formData.code" placeholder="请输入验证码">
              <template #append>
                <el-button
                  :disabled="codeLoading"
                  :loading="codeLoading"
                  type="primary"
                  size="small"
                  @click="getCode"
                >
                  {{ codeTip }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="flex flex-row justify-center">
          <el-button
            type="primary"
            style="width: 300px"
            round
            @click="loginEvent"
            >登录</el-button
          >
        </div>
      </div>
    </div>
    <!-- 微信扫码登录 -->
    <div v-else-if="loginType === 'wechat'" class="my-5" v-loading="loadingStatus">
        <h5 style="text-align: center">你还没有绑定公众号，绑定公众号即可接收消息通知。微信扫码即可</h5>
      <div class="flex justify-center items-center py-5">
        <div
          class="w-[200px] h-[200px] flex justify-center items-center bg-gray-100 rounded-lg"
        >
          <el-image
            v-if="ticket"
            :src="`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`"
            lazy
            class="w-[200px] h-[200px]"
          />
          <div v-else class="flex flex-col items-center gap-2.5 text-gray-400">
            <i class="el-icon-loading"></i>
            <span>二维码加载中...</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 账号密码登录   -->
    <div v-else-if="loginType === 'account'" class="login-content">
      <el-form class="login-form" :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="60px"
               @keyup.enter.native="submitForm('loginForm')">
        <div class="login-brand">
          <img class="logo" src="https://cdn.imgbed.link/file/23122" />
          <div>知识极客</div>
        </div>
        <el-form-item label="终端" prop="userName" v-show="false">
          <el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input type="userName" v-model="loginForm.userName" autocomplete="off"
                    placeholder="用户名"></el-input>

        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginForm.password" autocomplete="off"
                    placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          <el-button @click="resetForm('loginForm')">清空</el-button>
        </el-form-item>
        <div class="register">
          <el-button @click="loginType = 'register'">没有账号,前往注册</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import Icp from "@/components/common/Icp.vue";
let checkTimer=null;
const getTicket = () => {
  return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
  );
};
const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
export default {
  components: {Icp},
  mounted() {
    this.userId= this.userStore.userInfo.id;
    },
  data() {
    var checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'));
      }
      callback();
    };
    var checkNickName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入昵称'));
      }
      callback();
    };
    var checkPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      callback();

    };
    var checkConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入密码'));
      }
      if (value != this.registerForm.password) {
        return callback(new Error('两次密码输入不一致'));
      }
      callback();
    };
    return {
      visible: false,
      loginType:'wechat',
      busId:'',
      busType:'',
      loadingStatus:true,
      ticket:'',
      codeLoading:false,
      codeTip:'',
      formData: {
          email: "",
          code: "",
         agree: true,
    },
      loginForm: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        userName: '',
        password: ''
      },
      rules: {
        userName: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }]
      },
      registerForm: {
        userName: '',
        nickName: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {
        userName: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        nickName: [{
          validator: checkNickName,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }],
        confirmPassword: [{
          validator: checkConfirmPassword,
          trigger: 'blur'
        }]
      }
    }
  },
  computed:{
    width(){
      if(isMobileDevice()) return  '100%'
      return '40%'
    }
  },
  methods:{
    getWechatQrcode(){
      this.loadingStatus = true;
      // this.ticket = getTicket(); // 生成新的 ticket
      this.startCheckQrStatus(this.ticket); // 开始轮询
      setTimeout(() => {
        this.loadingStatus = false;
      }, 1000);
    },
    startCheckQrStatus(){
      if (checkTimer) {
        clearInterval(checkTimer);
      }
      checkTimer= setInterval(async () => {
        try {
          console.log("检查登录",this.ticket)
          this.$http({
            url: "/ignore/checkLogin?ticket="+this.ticket,
            method: 'get'
          }).then((data) => {
            if(!data?.accessToken) return
            this.setCookie('username', this.loginForm.userName);
            this.userStore.loadUser()
            // 保存token
            sessionStorage.setItem("accessToken", data.accessToken);
            sessionStorage.setItem("refreshToken", data.refreshToken);
            this.$message.success("登录成功");
            window.$loginDialog?.onSuccess?.();
            this.visible=false;
          })

        } catch (error) {
          console.error("检查扫码状态失败:", error);
        }
      }, 3000); // 每3秒检查一次
    },
    getCode(){
      console.log("获取验证码")
    },
    loginEvent(){
      console.log("开始登录")

    },
    showDialog(){
      if(!process.env["VUE_APP_BASE_APPID"]) return;
      this.visible=true;
      axios({
        url: "https://mp.klgeek.com/wx/wx/msg/"+process.env["VUE_APP_BASE_APPID"]+"/createTicket",
        method: 'post',
        data: {isTemp:true,sceneStr:'zsgeek'+this.userStore.userInfo.id,expireSeconds:120}
      }).then((res)=>{
        this.loadingStatus = false;
        this.ticket=res.data.data.ticket
      })
    },
    hideDialog(){
      this.visible=false;
    },
    handleClose (){
      this.visible=false;
      this.userStore.loadUser();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/login",
            method: 'post',
            data: this.loginForm
          })
              .then((data) => {
                // 保存密码到cookie(不安全)
                this.setCookie('username', this.loginForm.userName);
                this.userStore.loadUser()
                // 保存token
                sessionStorage.setItem("accessToken", data.accessToken);
                sessionStorage.setItem("refreshToken", data.refreshToken);
                this.$message.success("登录成功");
                window.$loginDialog?.onSuccess?.();
                this.visible=false;
              })

        }
      });
    },
    submitRegisterForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/register",
            method: 'post',
            data: this.registerForm
          }).then((data) => {
                this.$message.success("注册成功!");
              })
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取cookie、
    getCookie(name) {
      let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      let arr = document.cookie.match(reg)
      if (arr) {
        return unescape(arr[2]);
      }
      return '';
    },
    // 设置cookie,增加到vue实例方便全局调用
    setCookie(name, value) {
      document.cookie = name + "=" + escape(value);
    }
  }
}
</script>

<style lang="scss" scoped>
.line-box {
  transition: 0.4s;
  transform-origin: left;
  width: 40px;
  height: 3px;
  background: #e06711;
  border-radius: 5px;
  box-shadow: 1px 1px 3px -1px #e06711;
  margin-top: 5px;
}


  .login-content {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10%;

    .login-form {
      width: 400px;
      padding: 30px;
      background: white;
      opacity: 0.9;
      box-shadow: 0px 0px 1px #ccc;
      border-radius: 3%;
      overflow: hidden;
      border: 1px solid #ccc;

      .login-brand {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 50px;
        margin: 30px 0 40px 0;
        font-size: 22px;
        font-weight: 600;
        letter-spacing: 2px;
        text-transform: uppercase;
        text-align: center;

        .logo {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }

      .register {
        display: flex;
        flex-direction: row-reverse;
        line-height: 40px;
        text-align: left;
        padding-left: 20px;
      }
    }
}
.register-view {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  background: rgb(232, 242, 255);

  .web-ruleForm {
    padding: 20px;
    background: white;
    opacity: 0.9;
    border-radius: 3px;
    overflow: hidden;
    .register-brand {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 50px;
      margin: 20px 0 30px 0;
      font-size: 22px;
      font-weight: 600;
      letter-spacing: 2px;
      text-align: center;
      text-transform: uppercase;

      .logo {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }

    .to-login {
      display: flex;
      flex-direction: row-reverse;
      line-height: 40px;
      text-align: left;
      padding-left: 20px;
    }
  }
}
</style>
